import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class CryptoService {
  private iv = 'F27D5C9927726BCEFE7510B1BDD3D137';
  private salt = '3FF2EC019C627B945225DEBAD71A01B6985FE84C95A70EB132882F88C0A59A55';
  private keySize = 4;

  /**
   * Generates a key based on passphrase, iteration count and salt
   *
   * @param passPhrase
   * @param iterationCount
   */
  private generateKey(passPhrase: string, iterationCount: number) {
    let key: any;
    key = CryptoJS.PBKDF2(
      passPhrase,
      CryptoJS.enc.Hex.parse(this.salt),
      { keySize: this.keySize, iterations: iterationCount }
    );

    return key;
  }

  /**
   * Performs AES decryption for the given plaintext, using a passPhrase and iteration count for
   * creating the key used for decryption
   *
   * @param plaintext
   * @param passPhrase
   * @param iterationCount
   *
   * @return string
   */
  public decrypt(plaintext: string, passPhrase: string, iterationCount: number): string {
    const key = this.generateKey(passPhrase, iterationCount);
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(plaintext)
    });
    const decrypted = CryptoJS.AES.decrypt(
      cipherParams,
      key,
      { iv: CryptoJS.enc.Hex.parse(this.iv) }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  /**
   * Performs AES encryption for the given plaintext, using a passPhrase and iteration count for
   * creating the key used for encryption
   *
   * @param plaintext
   * @param passPhrase
   * @param iterationCount
   *
   * @return string
   */
  public encrypt(plaintext: string, passPhrase: string, iterationCount: number): string {
    const key = this.generateKey(passPhrase, iterationCount);
    const encrypted = CryptoJS.AES.encrypt(
      plaintext,
      key,
      { iv: CryptoJS.enc.Hex.parse(this.iv) }
    );

    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }

  /**
   * SHA-256 hash code as HEX string
   *
   * @param data
   *
   * @return string
   */
  public hashSha256(data: string): string {
    return CryptoJS.SHA256(data).toString(CryptoJS.encHex);
  }
}
